<template>
  <div class="home">
    <Nav />
    <!-- 首页论坛介绍 -->
    <div class="part part1" id="if2021-forum-desc">
      <img
        src="https://summit-img.geekpark.net/if2021/m/IF2021-竖版KV延展-m.png"
        class="img1"
      />
    </div>
    <div class="part part2">
      <img
        src="https://summit-img.geekpark.net/if2021/m/02-主题诠释-m.svg"
        class="img1"
      />
      <div class="desc-video-wrapper">
        <div class="video-container">
          <div class="cover" @click="playVideo" v-show="!videoStarted">
            <img
              src="https://summit-img.geekpark.net/if2021/pc/02-播放按钮-通用.svg"
              alt=""
            />
          </div>
          <video
            style="width: 100%; height: 100%"
            ref="video"
            poster="https://summit-img.geekpark.net/if2021/视频封面.jpg"
            controlslist="nodownload noremoteplayback"
            :controls="videoStarted"
          >
            <source
              type="video/mp4"
              src="https://summit-img.geekpark.net/if2021/video/if2021%E5%AE%A3%E4%BC%A0HD.mp4"
            />
          </video>
        </div>
      </div>
    </div>
    <!-- 日程 -->
    <div class="part part3" id="if2021-kv">
      <img
        src="https://summit-img.geekpark.net/if2021/m/03-日程-m-2.svg"
        class="img1"
      />
      <!-- 日程1/28 -->
      <img
        src="https://summit-img.geekpark.net/if2021/m/1.28-m-3.svg"
        class="img2"
      />
      <div class="kv128">
        <KvItem
          v-for="(guest, index) in guestsKv28"
          :key="index"
          :guest="guest"
        />
      </div>
      <!-- 日程1/29 -->
      <img
        src="https://summit-img.geekpark.net/if2021/m/1.29-m-3.svg"
        class="img3"
      />
      <div class="kv129">
        <KvItem
          v-for="(guest, index) in guestsKv29"
          :key="index"
          :guest="guest"
        />
      </div>
      <!-- 日程1/30下午 -->
      <img
        src="https://summit-img.geekpark.net/if2021/m/1.30-下午-m-3.svg"
        class="img4"
      />
      <div class="kv130-1">
        <KvItem
          v-for="(guest, index) in guestsKv30_1"
          :key="index"
          :guest="guest"
        />
      </div>
      <!-- 日程1/30晚上 -->
      <img
        src="https://summit-img.geekpark.net/if2021/m/1.30-晚上-m-3.svg"
        class="img5"
      />
      <div class="kv130-2">
        <KvItem
          v-for="(guest, index) in guestsKv30_2"
          :key="index"
          :guest="guest"
        />
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="part part4" id="if2021-partner">
      <img
        src="https://summit-img.geekpark.net/if2021/m/04-合作伙伴-m.svg"
        class="img1"
      />
      <div>
        <img
          src="https://summit-img.geekpark.net/if2021/m/合作伙伴-m-2.svg"
          class="img2"
        />
      </div>
    </div>
    <!-- 往届回顾 -->
    <div class="part part5" id="if2021-last-years">
      <img
        src="https://summit-img.geekpark.net/if2021/m/04-往届回顾-m.svg"
        class="img1"
      />
      <div class="year-list">
        <a href="http://ifx.geekpark.net">
          <img
            src="https://summit-img.geekpark.net/if2021/m/04-往届回顾-m-2020.svg"
            class="img2"
          />
        </a>
        <a href="http://if2019.geekpark.net">
          <img
            src="https://summit-img.geekpark.net/if2021/m/04-往届回顾-m-2019.svg"
            class="img3"
          />
        </a>
        <a href="http://if2018.geekpark.net">
          <img
            src="https://summit-img.geekpark.net/if2021/m/04-往届回顾-m-2018.svg"
            class="img4"
          />
        </a>
        <a href="http://if2017.geekpark.net">
          <img
            src="https://summit-img.geekpark.net/if2021/m/04-往届回顾-m-2017.svg"
            class="img5"
          />
        </a>
      </div>
    </div>
    <!-- 底部出品申明 -->
    <div class="part part6">
      <img src="https://summit-img.geekpark.net/if2021/m/footer-m-底部.svg" />
    </div>
    <div
      class="video_wrapper"
      id="geekpark_video_iframe_wrapper"
      style="display: none"
    >
      <div class="innner_black_bg" />
      <img
        alt="关闭视频"
        class="close_video_btn"
        src="https://summit-img.geekpark.net/r2020/close_video_btn.svg"
        @click="closeVideo"
      />
      <div class="link_line_close"></div>
      <iframe
        id="geekpark_video_iframe"
        style="
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          z-index: 99;
        "
        src=""
        frameborder="no"
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/mobile/Nav.vue";
import KvItem from "@/components/mobile/KvItem.vue";

export default {
  name: "HomeMible",
  data() {
    return {
      videoStarted: false,
      isPlaying: false,
    };
  },
  components: { Nav, KvItem },
  computed: {
    guestsKv28() {
      return this.$store.state.guestsList.kv28;
    },
    guestsKv29() {
      return this.$store.state.guestsList.kv29;
    },
    guestsKv30_1() {
      return this.$store.state.guestsList.kv30_1;
    },
    guestsKv30_2() {
      return this.$store.state.guestsList.kv30_2;
    },
  },
  mounted() {
    const video = this.$refs.video;
    setInterval(() => {
      if (!(video.paused || video.ended || video.seeking)) {
        this.isPlaying = true;
      } else {
        this.isPlaying = false;
      }
    }, 200);
  },
  methods: {
    playVideo() {
      this.$refs.video.play();
      this.videoStarted = true;
      this.isPlaying = true;
    },
    closeVideo() {
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      vIframeWrapper.style.display = "none";
      vIframe.src = "";
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #f3f3f3;
  min-height: 2000px;
  .part {
    img {
      width: 100vw;
      height: auto;
    }
  }
  .part2 {
    position: relative;
    .desc-video-wrapper {
      width: 100vw;
      height: 56vw;
      position: absolute;
      left: 0;
      bottom: 6vw;
      z-index: 3;
      .cover {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10;

        img {
          width: 13vw;
          height: 13vw;
        }
      }
    }
  }
  .part3 {
    .img1 {
      margin-bottom: 12vw;
    }
    .img2,
    .img3,
    .img4,
    .img5 {
      position: relative;
      z-index: 1;
    }
    .kv128 {
      width: 100vw;
      padding: 16vw 0 18vw;
      margin-top: -6vw;
      background: #f3f3f3
        url("https://summit-img.geekpark.net/if2021/m/1.28-背景-m-2.svg")
        no-repeat center 0 / cover;
      position: relative;
      overflow: hidden;
    }
    .kv129 {
      width: 100vw;
      padding: 16vw 0 18vw;
      margin-top: -6vw;
      background: #f3f3f3
        url("https://summit-img.geekpark.net/if2021/m/1.29-背景-m-2.svg")
        no-repeat -33vw 0 / cover;
      position: relative;
      overflow: hidden;
    }
    .kv130-1 {
      width: 100vw;
      padding: 16vw 0 18vw;
      margin-top: -6vw;
      background: #f3f3f3
        url("https://summit-img.geekpark.net/if2021/m/1.30-下午-背景-m-2.svg")
        no-repeat center 0 / cover;
      position: relative;
      overflow: hidden;
    }
    .kv130-2 {
      width: 100vw;
      padding: 16vw 0 18vw;
      margin-top: -6vw;
      background: #f3f3f3
        url("https://summit-img.geekpark.net/if2021/m/1.30-晚上-背景-m-2.svg")
        no-repeat center 0 / cover;
      position: relative;
      overflow: hidden;
    }
  }
  .part4 {
    .img1 {
      position: relative;
    }
    .img2 {
      margin-top: -13vw;
    }
  }
  .part5 {
    .year-list {
      padding: 6vw 0 22vw;
      text-align: center;
      a {
        text-decoration: none;
      }
      img {
        width: 86vw;
      }
    }
  }
  .part6 {
    text-align: center;
    padding-bottom: 10vw;
  }
  .video_wrapper {
    position: fixed;
    width: 90vw;
    height: 51vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #000;
    z-index: 9;
    .close_video_btn {
      position: absolute;
      top: -48px;
      left: 50%;
      transform: translateX(-50%);
      height: 26px;
      width: auto;
      z-index: 98;
      &:hover {
        cursor: pointer;
      }
    }
    .link_line_close {
      position: absolute;
      top: -32px;
      left: 50%;
      height: 60px;
      width: 4px;
      border-left: 1px solid #000;
    }
    .innner_black_bg {
      background: #000;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
}
</style>